import React from "react";
import Icon from "../Icon";
import { ValidationError } from "../types";
import { describeValidationError } from "./validationCopy";

interface Props {
  error: ValidationError;
  onOpenRecord?: (publicId: string) => void;
  onRemove: () => void;
}

const ValidationErrorBanner: React.FC<Props> = ({
  error,
  onOpenRecord,
  onRemove,
}) => (
  <div
    role="alert"
    className="validation-error-banner"
    style={{
      display: "flex",
      gap: 12,
      padding: 14,
      marginTop: 16,
      background: "var(--danger-bg)",
      border: "1px solid var(--border)",
      borderRadius: "var(--radius)",
      color: "var(--ink)",
    }}
  >
    <div style={{ color: "var(--danger)", flexShrink: 0, marginTop: 2 }}>
      <Icon name="alert-circle" size={18} />
    </div>
    <div style={{ flex: 1, minWidth: 0, lineHeight: 1.55 }}>
      <div style={{ fontSize: 13.5 }}>
        {describeValidationError(error, onOpenRecord)}
      </div>
      <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
        <button type="button" className="btn btn-sm" onClick={onRemove}>
          <Icon name="x" size={12} strokeWidth={2.5} /> Remove file
        </button>
      </div>
    </div>
  </div>
);

export default ValidationErrorBanner;
